export const goalStatusColors = {
  on_track: '#1a9e68',
  at_risk: '#e6821d',
  behind: '#d52a2a',
  upcoming: '#bfbfd4',
  no_status: '#cecede',
} as const;

// Status distribution bars keep attention on goals that need intervention.
export const goalStatusBarColors = {
  ...goalStatusColors,
  on_track: '#c9e9d9',
} as const;

export const goalStatusBarOrder = [
  'behind',
  'at_risk',
  'on_track',
  'upcoming',
  'no_status',
] as const;

export const goalStatusBarLabels = {
  behind: 'behind',
  at_risk: 'at risk',
  on_track: 'on track',
  upcoming: 'upcoming',
  no_status: 'no status',
} as const;

export const goalListStatusBarOrder = [
  'overdue',
  ...goalStatusBarOrder,
] as const;

// The overview bar shows health only; other states remain available to filters
// and grouped goal lists without being mixed into the bar's denominator.
export const goalHealthBarOrder = ['behind', 'at_risk', 'on_track'] as const;

export const goalListStatusBarColors = {
  ...goalStatusBarColors,
  overdue: goalStatusColors.behind,
} as const;

export const goalListStatusBarLabels = {
  ...goalStatusBarLabels,
  overdue: 'overdue',
} as const;

export type GoalPerformanceStatus = keyof typeof goalStatusColors;
